var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isMessageEnabled)?_c('div',{staticClass:"marquee"},[_c('span',[(_vm.msg_1)?_c('span',[_vm._v(_vm._s(_vm.msg_1))]):_vm._e(),(_vm.msg_2)?_c('span',[_vm._v(_vm._s(_vm.msg_2))]):_vm._e(),(_vm.msg_3)?_c('span',[_vm._v(_vm._s(_vm.msg_3))]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }